const basePath = "infrastructure-environmental-systems/";

export const racksCabling = {
  id: 11,
  category: "Racks & Cabling",

  filters: {
    Brand: { type: "checkbox" },
    Model: { type: "checkbox" },
    Dimensions: { type: "checkbox" },
    Features: { type: "checkbox" },
    Type: { type: "checkbox" },
    Capacity: { type: "checkbox" },
    Standards: { type: "checkbox" },
    "Load Rating": { type: "checkbox" },
    Materials: { type: "checkbox" },
    Speeds: { type: "checkbox" },
    Range: { type: "checkbox" },
    Lengths: { type: "checkbox" },
    Gauges: { type: "checkbox" },
  },

  subcategories: [
    {
      name: "Server Racks & Cabinets (42U/47U)",
      bestSeller: true,
      image: `${basePath}Server_Racks_&_Cabinets_(42U_47U).png`,
      details: {
        Brand: "APC/Rittal/Vertiv",
        Model: "Standard Server Rack",
        Dimensions: "19 inch / 42U to 47U",
        Features: "Cable management, cooling integration",
      },
      about: `
        <ul>
          <li>Industry-standard 19-inch equipment racks for organizing servers and infrastructure.</li>
          <li>Available with cable management, PDU mounting, and thermal features.</li>
        </ul>
      `,
    },
    {
      name: "Open-Frame Racks",
      bestSeller: false,
      image: `${basePath}Open-Frame_Racks.png`,
      details: {
        Brand: "StarTech/Vertical/APC",
        Type: "Open-Frame Rack",
        Capacity: "2U-42U options",
        Features: "Low cost, compact, tool-less assembly",
      },
      about: `
        <ul>
          <li>Cost-effective open-frame racks for labs, small deployments, and testing.</li>
          <li>Offer good airflow and easy equipment access.</li>
        </ul>
      `,
    },
    {
      name: "Rack Rails & Slide Kits",
      bestSeller: true,
      image: `${basePath}Rack_Rails_&_Slide_Kits.png`,
      details: {
        Brand: "APC/Rackmount/Generic",
        Type: "Slide-Out Rail Kits",
        Standards: "Universal 2-post / 4-post",
        Features: "Ease of maintenance, hot-swap support",
      },
      about: `
        <ul>
          <li>Adjustable rails enabling equipment to slide in and out of racks.</li>
          <li>Essential for server maintenance and replacement workflows.</li>
        </ul>
      `,
    },
    {
      name: "Rack Shelves & Mounting Brackets",
      bestSeller: true,
      image: `${basePath}Rack_Shelves_&_Mounting_Brackets.png`,
      details: {
        Brand: "APC/Rittal/StarTech",
        Type: "Fixed/Adjustable Shelves",
        "Load Rating": "50-300 lbs per shelf",
        Features: "Vented, fixed or adjustable depth",
      },
      about: `
        <ul>
          <li>Fixed or adjustable shelving for non-rackable equipment and accessories.</li>
          <li>Improve organization and cable management in data center racks.</li>
        </ul>
      `,
    },
    {
      name: "Cable Trays & Ladder Racks",
      bestSeller: true,
      image: `${basePath}Cable_Trays_&_Ladder_Racks.png`,
      details: {
        Brand: "Eaton/Panduit/Cableflow",
        Type: "Ladder / Wire Tray",
        Materials: "Steel, Aluminum, Stainless",
        Features: "Modular, high-capacity support",
      },
      about: `
        <ul>
          <li>Open cable management systems for large cable runs in data centers.</li>
          <li>Promote airflow and simplify routing for power, network, and fiber cables.</li>
        </ul>
      `,
    },
    {
      name: "Cable Managers (Horizontal/Vertical)",
      bestSeller: true,
      image: `${basePath}Cable_Managers_(Horizontal_Vertical).png`,
      details: {
        Brand: "APC/Legrand/Nexans",
        Type: "Horizontal/Vertical Cable Managers",
        Capacity: "200+ cables per manager",
        Features: "Tool-less, reusable ties",
      },
      about: `
        <ul>
          <li>Organized cable management systems for network and power cables in racks.</li>
          <li>Reduce airflow obstruction and simplify maintenance.</li>
        </ul>
      `,
    },
    {
      name: "Patch Panels (Cat6/Cat6a/Fiber)",
      bestSeller: true,
      image: `${basePath}Patch_Panels_(Cat6_Cat6a_Fiber).png`,
      details: {
        Brand: "Panduit/Legrand/CommScope",
        Type: "24/48 port Patch Panel",
        Standards: "Cat6/Cat6a/Multi-Mode Fiber",
        Features: "PoE compatible, managed",
      },
      about: `
        <ul>
          <li>Centralized connection points for network cabling termination and switching.</li>
          <li>Enable organized, flexible network reconfiguration.</li>
        </ul>
      `,
    },
    {
      name: "Fiber Optic Enclosures",
      bestSeller: false,
      image: `${basePath}Fiber_Optic_Enclosures.png`,
      details: {
        Brand: "Corning/CommScope/Panduit",
        Type: "Wall-Mount / Rack Fiber Enclosure",
        Capacity: "6-144 fiber strands",
        Features: "Splice trays, fusion splicing ready",
      },
      about: `
        <ul>
          <li>Enclosures for housing and protecting fiber optic splices and connections.</li>
          <li>Support organized fiber distribution and future expansion.</li>
        </ul>
      `,
    },
    {
      name: "Grounding Kits & Systems",
      bestSeller: true,
      image: `${basePath}Grounding_Kits_&_Systems.png`,
      details: {
        Brand: "Legrand/Panduit/Eaton",
        Type: "Equipotential Grounding",
        Standards: "IEEE/NEC Compliant",
        Features: "Copper busbars, bonding cables",
      },
      about: `
        <ul>
          <li>Grounding infrastructure ensuring equipotential bonding across all equipment.</li>
          <li>Critical for surge protection and safety compliance in data centers.</li>
        </ul>
      `,
    },
    {
      name: "Cat6/Cat6a Ethernet Cables",
      bestSeller: true,
      image: `${basePath}Cat6_Cat6a_Ethernet_Cables.png`,
      details: {
        Brand: "Panduit/Legrand/Corning",
        Type: "Twisted Pair Cabling",
        Standards: "Cat6A (10GbE), Cat6 (1GbE)",
        Features: "Shielded/Unshielded options",
      },
      about: `
        <ul>
          <li>High-performance copper cabling for network connectivity up to 100m runs.</li>
          <li>Cat6A supports 10 Gbps; essential for modern data center networks.</li>
        </ul>
      `,
    },
    {
      name: "Fiber Optic Cables (SMF/MMF)",
      bestSeller: true,
      image: `${basePath}Fiber_Optic_Cables_SMF_MMF.svg`,
      details: {
        Brand: "Corning/Nextel/Lucent",
        Type: "Single-Mode (SMF) / Multi-Mode (MMF)",
        Standards: "ITU-T G.652 / G.655",
        Features: "Low-loss, long-distance capable",
      },
      about: `
        <ul>
          <li>Single-mode fiber for long-distance backbone links; multi-mode for short/medium runs.</li>
          <li>Immune to electromagnetic interference; support 10Gbps to 400Gbps speeds.</li>
        </ul>
      `,
    },
    {
      name: "AOC / DAC Cables (Direct Attach)",
      bestSeller: false,
      image: `${basePath}AOC_DAC_Cables.svg`,
      details: {
        Brand: "Mellanox/Arista/Amphenol",
        Type: "Active Optical / Direct Attach Copper",
        Speeds: "10G-400G",
        Range: "3-30m for DAC, 100m+ for AOC",
      },
      about: `
        <ul>
          <li>High-speed interconnects between switches and high-performance servers.</li>
          <li>DAC for short runs (&lt;10m), AOC for longer distances or interference avoidance.</li>
        </ul>
      `,
    },
    {
      name: "Patch Cords (Copper/Fiber)",
      bestSeller: true,
      image: `${basePath}Patch_Cords_(Copper_Fiber).png`,
      details: {
        Brand: "Panduit/Legrand/Belden",
        Type: "Copper UTP / Fiber LC/SC/ST",
        Lengths: "1m-30m standard",
        Features: "Pre-terminated, field-installable",
      },
      about: `
        <ul>
          <li>Pre-terminated connection cables for quick deployment and reconfigurations.</li>
          <li>Available in copper (RJ45) and fiber (LC, SC, ST) connectors.</li>
        </ul>
      `,
    },
    {
      name: "MPO/MTP Fiber Trunks",
      bestSeller: false,
      image: `${basePath}MPO_MTP_Fiber_Trunks.svg`,
      details: {
        Brand: "CommScope/Corning/Panduit",
        Type: "12/24-fiber MPO/MTP Assemblies",
        Standards: "IEC 61076-2-109",
        Features: "High-density, breakout kits",
      },
      about: `
        <ul>
          <li>High-density fiber bundles for 40G/100G/400G data center networks.</li>
          <li>MPO/MTP connectors provide 12/24 fiber termination in single connector.</li>
        </ul>
      `,
    },
    {
      name: "Fibre Channel Cables",
      bestSeller: false,
      image: `${basePath}Fibre_Channel_Cables.png`,
      details: {
        Brand: "Brocade/Emulex/Qlogic",
        Type: "FC/SFP+ Cables",
        Standards: "FC 1G/2G/4G/8G/16G",
        Features: "LC/RJ45 connectors, multimode",
      },
      about: `
        <ul>
          <li>Specialized optical cables for Fibre Channel SAN connectivity.</li>
          <li>Support high-speed storage traffic up to 16 Gbps per lane.</li>
        </ul>
      `,
    },
    {
      name: "SAS Cables (Serial Attached SCSI)",
      bestSeller: false,
      image: `${basePath}SAS_Cables.svg`,
      details: {
        Brand: "Amphenol/Molex/Hirose",
        Type: "SAS Cables",
        Standards: "SAS 1.0/2.0/3.0",
        Features: "3m/5m standard, shielded",
      },
      about: `
        <ul>
          <li>High-speed serial cabling for storage system internal connectivity.</li>
          <li>Support 3Gbps, 6Gbps, and 12Gbps SAS speeds with hot-swappable design.</li>
        </ul>
      `,
    },
    {
      name: "InfiniBand Cables",
      bestSeller: false,
      image: `${basePath}InfiniBand_Cables.png`,
      details: {
        Brand: "Mellanox/Intel/Amphenol",
        Type: "IB EDR/HDR Cables",
        Standards: "IB SDR/DDR/QDR/FDR/EDR",
        Features: "100Gbps capable, active/passive",
      },
      about: `
        <ul>
          <li>Ultra-high-speed interconnects for HPC clusters and data analytics.</li>
          <li>InfiniBand support 25Gbps to 200+ Gbps per port with low latency.</li>
        </ul>
      `,
    },
    {
      name: "C13/C14 Power Cords",
      bestSeller: true,
      image: `${basePath}C13_C14_Power_Cords.png`,
      details: {
        Brand: "Panduit/Legrand/Eaton",
        Type: "IEC 60320 C13/C14",
        Gauges: "16 AWG / 1.5-3m standard",
        Features: "Locking, strain-relief options",
      },
      about: `
        <ul>
          <li>Standard power cords connecting equipment to PDUs and UPS systems.</li>
          <li>Widely used for rack-mount servers, switches, and infrastructure equipment.</li>
        </ul>
      `,
    },
    {
      name: "C19/C20 Power Cords",
      bestSeller: true,
      image: `${basePath}C19_C20_Power_Cords.png`,
      details: {
        Brand: "Panduit/Legrand/Eaton",
        Type: "IEC 60320 C19/C20",
        Gauges: "12 AWG / 1.5-2m standard",
        Features: "Heavy-duty, 20A rated",
      },
      about: `
        <ul>
          <li>Heavy-duty power cords rated for 20A at 250V AC.</li>
          <li>Used for connecting PDUs to main power distribution and UPS systems.</li>
        </ul>
      `,
    },
    {
      name: "IEC / NEMA Power Cords",
      bestSeller: true,
      image: `${basePath}IEC___NEMA_Power_Cords.png`,
      details: {
        Brand: "Generic/Legrand/Panduit",
        Type: "IEC/NEMA-5-15/NEMA-L6-20",
        Standards: "Varies by region",
        Features: "Regional, grounding, locking",
      },
      about: `
        <ul>
          <li>Regional power cords for facilities with North American (NEMA) infrastructure.</li>
          <li>Support various voltage/amperage ratings depending on regional standards.</li>
        </ul>
      `,
    },
  ],
};
